import { AES_Decrypt } from "@/utils/encryp.js";

export const clarityAddCustomTags = () => {
  try {
    if (window.clarity) {
      const customTags = {
        // userId: localStorage.getItem("userId") || "",
        // userNo: localStorage.getItem("userNo") || "",
        email: AES_Decrypt(localStorage.getItem("email") || ""),
      };
      Object.entries(customTags).forEach(([key, value]) => {
        window.clarity("set", key, value);
      });
    }
  } catch (e) {
    console.log("clarityAddCustomTags error");
    console.log(e);
  }
};
